<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">仕入先マスタ一覧</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          v-if="showFlags.btn_supplierCtrl_10003"
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="dl()"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button>
        <button
          v-if="showFlags.btn_supplierCtrl_10003"
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="$router.push('/supplierEdit')"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>検索条件</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-search">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">キーワード</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="domKeyword"
                    @keydown.enter="getlist(1)"
                  />
                </div>
                <!-- <div class="col-md-1 contTitle">仕入先コード</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <div class="input-daterange input-group" id="datepicker-5">
                    <input
                      type="text"
                      class="form-control"
                      name="start"
                      v-model="domIdStart"
                    />
                    <div class="input-group-append input-group-prepend">
                      <span class="input-group-text fs-xl" style="height: 34px"
                        >－</span
                      >
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      name="end"
                      v-model="domIdEnd"
                    />
                  </div>
                </div>
                <div class="col-md-1 contTitle">仕入先名</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <input
                    type="text"
                    name="txtSupplierNm"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="domClientName"
                  />
                </div> -->
              </div>
              <!-------------------->
              <div class="row">
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-themed btn-search mx-auto"
                  :disabled="btnDisable"
                  @click="getlist(1)"
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>条件結果</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-list">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <!-- good table start -->
              <!-- <vue-good-table :columns="columns" :rows="rows">
                <template #table-row="props">
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <a
                      v-bind:href="
                        '/jyutyuinput?record_id=' + props.row.c_project_number
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-xs btn-primary waves-effect waves-themed"
                      >
                        詳細
                      </button>
                    </a>
                  </div>
                  <div
                    v-else-if="
                      props.column.field == 'c_sales_date_cmp_payment_short'
                    "
                    class="gtablecell btnDetCell"
                  >
                    <span class="dateRow_id">
                      <input
                        type="date"
                        name="txtClientNm"
                        class="form-control form-control-sm dateInput"
                        maxlength="200"
                        :value="props.formattedRow[props.column.field]"
                      />
                      <span class="salesId">{{ props.row.c_sales_id }}</span>
                    </span>
                  </div>

                  <div v-else class="gtablecell">
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </template>
              </vue-good-table> -->
              <vue-good-table
                mode="remote"
                v-on:page-change="onPageChange"
                v-on:sort-change="onSortChange"
                :columns="columns"
                :rows="delegate.items"
                :sort-options="{
                  enabled: false,
                }"
                :pagination-options="{
                  enabled: false,
                  // perPageDropdownEnabled: false,
                  // jumpFirstOrLast: true,
                  // page: 1,
                  // perPage: 10,
                  // nextLabel: '次へ',
                  // prevLabel: '前へ',
                  // mode: 'pages',
                  // ofLabel: '～',
                  // pageLabel: '',
                }"
                :totalRows="delegate.pager.maxcount"
              >
                <template #table-row="props">
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <button
                      type="button"
                      class="btn btn-xs btn-primary waves-effect waves-themed btn-block"
                      @click="
                        goTo(
                          '/supplierEdit?id=' + props.row.c_supplier_id,
                          $event
                        )
                      "
                    >
                      詳細
                    </button>
                  </div>
                  <div v-else class="gtablecell">
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </template>
              </vue-good-table>
              <!-- good table end -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { DtoSuppliersGetResImple } from "furukawa-common/src/common/dto/DtoSuppliersGetResImple";
import { Cl_common } from "@/functions/Cl_common";
import { DtoSuppliersGetReqImple } from "furukawa-common/src/common/dto/DtoSuppliersGetReqImple";
import { Cl_supplier } from "@/functions/Cl_supplier";
import { Cl_Authorization_menu } from "@/constants/Cl_Authorization_menu";
import { DtoFileMastersGetReqImple } from "furukawa-common/src/common/dto/DtoFileMastersGetReqImple";
import { Cl_filemaster } from "@/functions/Cl_filemaster";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class SupplierList extends Vue {
  /**
   * パフォーマンス問題の解決案としてテスト的に実装中
   * 残課題：グローバルなメソッドとして宣言して、どこからでも呼び出せるようにしたい
   * 　　　　色々なパターンでも問題ないかの検証
   * @param url
   * @param event
   */
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoSuppliersGetResImple();
  showFlags = new Cl_Authorization_menu();
  //ボタン制御用
  btnDisable = false;

  //検索条件dom
  domIdStart = "";
  domIdEnd = "";
  domClientName = "";
  domKeyword = "";

  columns = [
    {
      label: "詳細",
      field: "btnDet",
      width: "10%",
    },
    {
      label: "仕入先コード",
      field: "c_supplier_id",
    },
    {
      label: "仕入先名",
      field: "c_supplier_name",
    },
    {
      label: "ふりがな",
      field: "c_supplier_name_pt",
    },
    {
      label: "担当者名",
      field: "c_supplier_staff_name",
    },
    {
      label: "ふりがな",
      field: "c_supplier_staff_name_pt",
    },
  ];

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalErrorConf = "";

  //----------------------
  //基本操作用メソッド
  //----------------------
  async mounted() {
    await this.getlist(1);
    //設定された権限からメニューの表示非表示を制御
    this.showFlags.getAuthorization(this.$store);
  }

  /**
   * 一覧データを読み込む
   */
  async getlist(currentPage: number) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoSuppliersGetReqImple();

      //検索条件設定
      // dto.pager.count = CONST_LIST_DEFO_COUNT;
      dto.pager.count = 9999;
      dto.pager.cursor = currentPage;
      // if (this.domIdStart != "" && this.domIdStart != null)
      //   dto.SuppliersId_start = Number(this.domIdStart);
      // if (this.domIdEnd != "" && this.domIdEnd != null)
      //   dto.SuppliersId_end = Number(this.domIdEnd);

      // dto.SuppliersName = this.domClientName;

      dto.keyword = this.domKeyword;

      //API実行
      //-------
      this.delegate = await Cl_supplier.getList(dto);
      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      //エラー発生で一覧を初期化
      this.delegate = new DtoSuppliersGetResImple();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "ShiiresakiList";
      dto.keyword = this.domKeyword;

      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);
      console.log(res);
      console.log(res.url);

      //レスポンス処理
      //-------
      location.href = res.url;
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  async moveDet(id: string) {
    //詳細ページに移動
    this.$router.push("/supplierEdit?id=" + id);
  }
  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    await this.getlist(params.currentPage);
  }
  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
